import { Row } from "PFApp/booking/types";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useMemo } from "react";

import { getOriginalResource } from "../../../../helpers";
import { WorkforceCalendarData } from "../../../context/booking_overview_context.types";
import { useBookingRowsContext } from "../../../context/booking_rows_context";
import { useBookingsOverviewContext } from "../../../context/bookings_overview_context";
import { HeatMap } from "./heat_map_item.types";

type UseHeatMapItems = {
  row: Row;
  dayWidth: number;
  startDate: string;
};

export const useHeatMapItems = ({ row, startDate, dayWidth }: UseHeatMapItems): HeatMap[] => {
  const { calendarMode } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { availabilitiesByProfile } = useBookingRowsContext();

  const profileId = getOriginalResource(row, calendarMode)?.id;

  const { utc } = useDateFormatter();
  return useMemo(
    () =>
      (profileId ? availabilitiesByProfile[profileId] || [] : [])
        // eslint-disable-next-line camelcase
        .filter(({ billable_utilization }) => billable_utilization != null) // eslint-disable-line eqeqeq
        .map((availability) => {
          const date = "date" in availability ? availability.date : availability.start_date;
          const daysFromStart = utc(date).diff(utc(startDate), "days");
          const durationInDays =
            "date" in availability
              ? 1
              : utc(availability.end_date).diff(utc(availability.start_date), "days") + 1;
          return {
            ...availability,
            date,
            left: daysFromStart * dayWidth,
            width: durationInDays * dayWidth
          };
        }),
    [availabilitiesByProfile, profileId, startDate, dayWidth, utc]
  );
};
